import React, { useState, useEffect } from "react";
import { useSpinnerContext } from '@contexts';
import { useLocation, useNavigate } from 'react-router-dom';
import { helpers } from "@shared";
import { sunboundPayProxy } from '@proxies';
import { AutoPay, PaymentDay } from ".";
import { useAllowedPaymentTypes } from "../hooks/useAllowedPaymentTypes/useAllowedPaymentTypes";

const StepAutoPay = () => {

    const navigate = useNavigate(), location = useLocation();
    const { setSpinnerShow } = useSpinnerContext();
    const [autoPay, setAutoPay] = useState(true);
    const [selectedAutodrawDay, setSelectedAutodrawDay] = useState(1);

    const {
        state: {
            account,
            idProductType = null
        }
    } = location;
    const {
        idAccount,
        orgDays,
        paymentPreferences: { defaultPaymentMethod },
        accountPreferences,
        potDeadline
    } = account;
    const { dueDay: payorDueDay } = accountPreferences;

    const { allowedPaymentTypes } = useAllowedPaymentTypes();
    const defaultPaymentMethodAllowed = allowedPaymentTypes.includes(defaultPaymentMethod.idPaymentType);

    const { locked, autodrawDay, maxDay } = helpers.getDaysFromPayor(orgDays, payorDueDay, idProductType, potDeadline);

    useEffect(() => {
        window.scrollTo(0, 0);
        setSelectedAutodrawDay(autodrawDay);
    }, []);

    const setDay = (autodrawDay) => {
        setSelectedAutodrawDay(autodrawDay);
    };

    const onClick = async () => {

        setSpinnerShow(true);
        try {
            const updateDueDay = autoPay ? selectedAutodrawDay : undefined;
            await sunboundPayProxy.updateAccountPayorPreferences(idAccount, { isAutoPay: autoPay, dueDay: updateDueDay });
            const update = { ...account, accountPreferences: { ...accountPreferences, dueDay: updateDueDay, isAutoPay: autoPay } };
            helpers.navigateNext(location, navigate, { isAutoPay: autoPay }, { account: update });
        } catch (error) {
            console.log(error);
        }
        setSpinnerShow(false);
    };

    return (
        <div className="page-content-wrapper">
            <h1 className="page-header">Turn on auto-pay</h1>
            <span className="page-subheader text-left">By clicking <b>Continue</b> you are authorizing Sunbound to debit your account for your total monthly balance on your payment date.</span>
            <AutoPay setAutoPay={setAutoPay} autoPay={autoPay} paymentMethod={defaultPaymentMethod} />
            {
                autoPay &&
                <PaymentDay setDueDay={setDay} dueDay={selectedAutodrawDay} locked={locked} maxDay={maxDay}/>
            }
            <button type="button" className="btn btn-primary text-xl mt-4 rounded-full" disabled={!defaultPaymentMethodAllowed} onClick={onClick}>Continue</button>
        </div>
    );
};

export default StepAutoPay;
